<div class="overall-card" [ngClass]="scoreClass()">

  <!-- Header: title only -->
  <div class="overall-card__header">
    <div class="overall-card__title">
      <mc-icon icon="check-circle" size="20"></mc-icon>
      <span class="mds-text--medium-bold">Overall Score</span>
    </div>
  </div>

  <!-- Loading state -->
  @if (isLoading()) {
    <div class="overall-card__loading">
      <mc-loading-indicator label="Loading score data" hiddenlabel variant="ring" fit="small"></mc-loading-indicator>
    </div>
  }

  <!-- Error state -->
  @if (!isLoading() && hasError()) {
    <p class="overall-card__error mds-text--small-normal mds-neutral--weak__text-color">
      Failed to load score data. Please try again.
    </p>
  }

  <!-- Data state -->
  @if (!isLoading() && !hasError() && selectedEntry()) {

    <!-- Score value -->
    <div class="overall-card__score">
      <span class="overall-card__score-value" [ngClass]="scoreClass() + '-text'">
        {{ displayScore() }}
      </span>
      <span class="overall-card__score-max mds-neutral--weak__text-color">
        &nbsp;/ {{ displayMax() }}
      </span>
    </div>

    <!-- Progress bar + percentage label -->
    <div class="overall-card__progress-row">
      <div class="overall-card__progress-track">
        <div
          class="overall-card__progress-fill"
          [ngClass]="scoreClass() + '-fill'"
          [style.width]="progressWidth()">
        </div>
      </div>
      <span class="overall-card__progress-pct mds-text--x-small-normal mds-neutral--weak__text-color">
        {{ displayScore() }}{{ isShopView() ? '/5' : '%' }}
      </span>
    </div>

    <!-- Legend -->
    <div class="overall-card__legend">
      <div class="overall-card__legend-items">
        <span class="mds-text--x-small-normal mds-neutral--weak__text-color">Last 8 Months Trend</span>
        <span class="overall-card__legend-line overall-card__legend-line--solid" [ngClass]="scoreClass() + '-swatch'"></span>
        <span class="mds-text--x-small-normal mds-neutral__text-color">Current</span>
        <span class="overall-card__legend-line overall-card__legend-line--dashed"></span>
        <span class="mds-text--x-small-normal mds-neutral--weak__text-color">Prior Year</span>
      </div>
      @if (trendDelta() !== null) {
        <span class="overall-card__trend-delta mds-text--x-small-normal" [class.overall-card__trend-delta--positive]="trendIsPositive()">
          {{ trendLabel() }}
        </span>
      }
    </div>

    <!-- Trend chart -->
    <div class="overall-card__chart-container">
      <canvas #overallChart></canvas>
    </div>

  }
</div>
